import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=52d91f7a&scoped=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"
import style0 from "./banner.vue?vue&type=style&index=0&id=52d91f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d91f7a",
  null
  
)

export default component.exports